define('extensions/lodash/maybe',[
], function () {
    'use strict';

    var Maybe = function(value){
        var self = this;
        var nothing = function () {
            return new Maybe(null);
        };
        var just = function (newVal) {
            return new Maybe(newVal);
        };
        self.map = function (func) {
            return !value ? nothing() : just(func(value));
        };
        self.flatMap = function (func) {
            var tempMaybe = func(value);
            if (tempMaybe instanceof Maybe){
                return tempMaybe;
            }
            else {
                throw new Error("your function does not return a maybe");
            }
        };
        self.get = function(){
            return !value ? null : value;
        };
        self.getOrElse = function(func){
            return !value ? func() : value;
        };
        self.hasValue = function(){
            return !!value;
        };
    };

    // Return a basic object so we can call _.mixin in the main dependency injection file
    // ("mixins.js").
    return {
        /**
         * Maybe Example
         *
         * flatMap (monad/comonad)
         * var value = _.maybe("hey")
         *               .flatMap(function(x){
         *                  return _.maybe(x + " buddy");
         *               })
         *               .get();
         *
         * functor
         * _.maybe("hey").map(function(x){ return x + " you"}).get()
         *
         * //else get fallback
         * _.maybe(null).getOrElse(function(){return "asdfasdf"});
         *
         * @param value
         * @returns {Maybe}
         */
        maybe: function (value) {
            return new Maybe(value);
        }
    };
});

